module.exports = __webpack_public_path__ + "static/media/img3.4ba8ea8d.png";